import { useState } from "react";
import { Images } from "../Components/Utils/ImagePath";

export function Logo({ src, alt, height = 30 }) {
  const [status, setStatus] = useState(!src ? "error" : "loading");
  // "loading" | "loaded" | "error"

  return (
    <div>
      {status === "loading" && <span className="spinner" />}

      {status === "error" && (
        <img
          src={Images.logoNewBlack}
          alt="fallback"
          height={height}
        />
      )}
      {src && (
        <img
          src={src}
          alt={alt}
          className="logo-image-lg"
          height={height}
          style={{ display: status === "loaded" ? undefined : "none" }}
          onLoad={() => setStatus("loaded")}
          onError={() => setStatus("error")}
        />
      )}
    </div>
  );
}